import React, { Fragment } from 'react'

import { Typo } from 'components/_old/Typo'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

export const AdditionalInfo: React.FC = () => {
  const declarationFieldset = (
    <Fragment>
      <Typography size={24} lineHeight="small" weight="semibold">
        <Typo>Confirm your ISA transfer</Typo>
      </Typography>
      <Paper top={32}>
        <Typography size={14}>
          <Typo>
            Before you submit your ISA transfer request, please read the following carefully and confirm you understand
            and agree.
            <br />
            <br />I want to transfer the funds I’ve subscribed to an existing ISA to my InvestEngine Stocks & Shares
            ISA, based on the details I’ve provided.
            <br />
            <br />I understand:
          </Typo>
          <ul style={{ marginTop: 0, marginBottom: 0 }}>
            <li>My current ISA provider may charge fees for transferring.</li>
            <li>There may be a period when my money is not invested during the transfer process.</li>
            <li>
              InvestEngine only supports ETFs available on its platform. If I hold other types of investments, or ETFs
              not offered by InvestEngine, my current provider will sell them during the transfer. The money will then
              be sent to InvestEngine and invested in my chosen portfolio.
            </li>
            <li>
              This may result in a temporary loss of market exposure and could affect the value of my investments.
            </li>
          </ul>
          <br />
          <Typo>
            I’ve received, read and agreed to InvestEngine (UK) Limited’s Terms and Conditions, including the Additional
            Terms for Stocks & Shares ISAs.
          </Typo>
        </Typography>
      </Paper>
    </Fragment>
  )

  const authorityFieldset = (
    <Fragment>
      <Typography size={24} lineHeight="small" weight="semibold">
        <Typo>What you’re authorising</Typo>
      </Typography>
      <Paper top={32}>
        <Typography size={14}>
          <Typo>By confirming this transfer, I authorise:</Typo>
          <br />
          <br />
          <ul style={{ marginTop: 0, marginBottom: 0 }}>
            <li>
              InvestEngine to hold and manage my ISA investments, cash, interest, dividends, and any other proceeds.
            </li>
            <li>InvestEngine to make tax relief claims on my behalf for ISA investments.</li>
            <li>
              My existing ISA provider to sell investments where needed and send the cash proceeds to InvestEngine.
            </li>
            <li>
              InvestEngine to contact my current ISA provider to complete the transfer and share relevant information in
              line with the Data Protection Act 2018.
            </li>
          </ul>
        </Typography>
      </Paper>
    </Fragment>
  )

  return (
    <div>
      {declarationFieldset}
      <Paper top={40}>{authorityFieldset}</Paper>
    </div>
  )
}
